export enum IDENT_TYPES {
  PATIENT = 'patient',
  REPRESENTATIVE = 'representative',
  PROFESSIONAL = 'professional',
  PERSON = 'person',
}
